import { h, defineComponent } from 'vue';
import LoaderComponent from '@/components/Loader.vue';

export default ({ Component, Loader, Catch }) => {
  if (!Component.name) {
    console.error('Component should have name', Component);
  }
  
  return defineComponent({
    name: 'LoaderWrapper' + Component.name,
    components: {
      LoaderComponent,
    },
    render() {
      return h(LoaderComponent, {
        component: Component,
        loader: Loader,
        fallback: Catch,
      });
    },
  });
};
